import React, { useEffect, useState, } from 'react'
import { Modal, } from 'react-bootstrap'

import axios from 'axios';

import { v4 as uuidv4 } from 'uuid';
import HtmlParser from 'react-html-parser';

import {
    dataTableLanguaje, formatBytes, buttonProcessGet, customFileNameGet, responseGet, globalSettings, styles, checkFile, documentMaxFilesMessageGet,
    sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, awaitDelay, LoadingSection,
} from '../../helpers/settings';
import { fileUploadAsync } from '../../controllers/dataBase/actions';
import Swal from 'sweetalert2';
import { fileModelGet } from '../../models/main/files';
import { buildingDocumentModelGet } from '../../models/buildings/buildingDocument';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'BuildingDocumentAddDetailEdit';

const { app, icons, images, labels, messages, react: reactSett, } = globalSettings;
const { backend, } = app;

export default function BuildingDocumentAddDetailEdit({
    $ = {},
    document = buildingDocumentModelGet({}),
    setDocument = () => { },
    processValues = {
        auth: {},
        documentShowModal: false,
        type: 0,
        dtId: '',
        dtRowIndex: 0,
    },
    setProcessValues = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    let filesDtRow = [];
    //const btnFileDeleteId = 'btnDeleteFile';
    const inputFileId = 'inputFile';
    const [fileDelete, setFileDelete] = useState({});
    const dtFilesId = 'dtFilesId';
    const [files, setFiles] = useState([]);
    const [filesTwo, setFilesTwo] = useState([]);
    const [filesAccept, setFilesAccept] = useState('');
    const fileTypes = globalSettings?.app?.fileTypes?.images?.concat(
        globalSettings?.app?.fileTypes?.filesOne,
        globalSettings?.app?.fileTypes?.filesTwo,
        globalSettings?.app?.fileTypes?.filesThree);
    const [titleError, setTitleError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [attachmentError, setAttachmentError] = useState('');
    const processDocuments = {
        fileOpen: 'buildingDocumentFileOpen',
        fileDelete: 'buildingDocumentFileDelete',
    };
    const controls = {
        buttons: {
            save: {
                className: 'btn btn-outline-primary mx-1',
                id: 'btnModalBDADESave',
            },
            attachment: {
                className: 'btn btn-outline-info btn-file',
                id: 'btnModalBDADEAttachtmen',
            },
            back: {
                className: 'btn btn-outline-success mx-1',
                id: 'btnModalBDADEBack',
            },
            delete: {
                className: 'btn btn-outline-danger',
                id: 'btnModalBDADEDelete',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalBDADEClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            buildings: {
                inputs: {
                    search: {
                        id: `${dtFilesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtFilesId}_length select`,
                        className: '',
                    },
                },
            },
        },
        icons: {
            save: {
                className: icons?.save,
                id: 'icoModalBDADESave',
            },
            attachment: {
                className: icons?.paperClip,
                id: 'icoModalBDADEAttachtmen',
            },
            back: {
                className: icons?.arrowCircleLeft,
                id: 'icoModalBDADEBack',
            },
        },
        inputs: {
            title: {
                id: 'inputModalBDADETitle',
                className: 'form-control',
            },
            description: {
                id: 'inputModalBDADEDescription',
                className: 'form-control',
            },
        },
        spinners: {
            save: {
                className: '',
                id: 'spModalBDADESave',
            },
            attachment: {
                className: '',
                id: 'spModalBDADEAttachtmen',
            },
            back: {
                className: '',
                id: 'spModalBDADEBack',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    const [showLoading, setShowLoading] = useState({ files: false, });
    //#endregion variables

    //#region methods (documents)
    const buildingDocumentFileOpen = async ({ e = {}, id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'buildingDocumentFileOpen';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let fileLocal = fileModelGet({});
            //#endregion variables

            //#region find document
            if (!isUndNullEmp({ data: document?.files, subMethod: currentMethod, })?.result && document?.files?.length > 0) {
                fileLocal = document?.files?.find(({ id: idLocal, }) => idLocal === id);
                if (!isUndNullEmp({ data: fileLocal, subMethod: currentMethod, })?.result) {
                    if (!isUndNullEmp({ data: fileLocal?.url, subMethod: currentMethod, })?.result) {
                        setShowLoading({ files: true, });
                        //#region check if file exists
                        headerObj = {
                            headers: {
                                authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };

                        dataObj = {
                            conditionals: [],
                            ordersBy: [],
                            folder: backend?.documents?.buildingDocuments,
                            fileName: fileLocal?.id,
                            method: backend?.methods?.fileUrlDownloadGet,
                            buildingId: document?.buildingId,
                            languageId: languageObj?.id,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlFiles}/`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ files: false, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: processValues?.auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        //fileLocal.url = response.result;
                        fileLocal.url = response.result?.url;
                        //#endregion check if file exists

                        window?.open(fileLocal?.url, '_blank');
                        setShowLoading({ files: false, });
                    } else {
                        response.msgType = 1;
                        response.msgText = `${messages?.theFileCannotBeLocated?.[languageObj?.id]}<br/>`;
                        response.msgText += `${labels?.file?.[languageObj?.id]}: <b>${description}</b>`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: processValues?.auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                }
            }
            //#endregion find document

            setShowLoading({ files: false, });
        } catch (ex) {
            setShowLoading({ files: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const buildingDocumentFileDeleteGetAsync = async ({ e = {}, fileId = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'buildingDocumentFileDeleteGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region old code
            // //#region show message
            // const swalProperties = {
            //     icon: reactSett?.sweetAlert2?.icons?.warning,
            //     title: messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: `${labels?.file?.[languageObj?.id]}: <b>${description}</b><br/>${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: labels?.no?.[languageObj?.id],
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal.fire(swalProperties);

            // if (isConfirmed) {
            //     setFileDelete({ fileId, description, rowIndex });
            //     $(`#${controls?.buttons?.delete?.id}`)?.trigger('click');
            // }
            // //#endregion show message
            //#endregion old code

            setFileDelete({ fileId, description, rowIndex });
            $(`#${controls?.buttons?.delete?.id}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const buildingDocumentFileDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buildingDocumentFileDeletePostAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let isDeleted = false;
            const fileId = fileDelete?.fileId;
            const description = fileDelete?.description;
            const rowIndex = fileDelete?.rowIndex;
            //#endregion variables

            if (processValues?.type === 1) {
                if (!isUndNullEmp({ data: document?.files, subMethod: currentMethod, })?.result && document?.files.length > 0) {
                    //#region show message
                    let msgTextObj = {
                        one: `${labels?.file?.[languageObj?.id]}: <b>${description}</b><br/>`,
                        two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    let swalProperties = {
                        icon: reactSett?.sweetAlert2?.icons?.warning,
                        title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        html: `${msgTextObj?.one}${msgTextObj?.two}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: globalSettings?.colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true, //!Swal.isLoading(), //true,
                        cancelButtonColor: globalSettings?.colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        preConfirm: async () => {
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal?.update({
                                    icon: reactSett?.sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}...`,
                                    html: msgTextObj?.one,
                                    showConfirmButton: false,
                                });

                                //#region clear files
                                let buildingDocumentFilesLocal = document?.files?.filter(({ id, }) => id !== fileId);
                                if (isUndNullEmp({ data: buildingDocumentFilesLocal, subMethod: currentMethod, })?.result || buildingDocumentFilesLocal?.length === 0) {
                                    buildingDocumentFilesLocal = [];
                                }
                                //#endregion clear files

                                //#region delete file (physical)
                                headerObj = {
                                    headers: {
                                        authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                                    },
                                };

                                dataObj = {
                                    conditionals: [],
                                    ordersBy: [],
                                    buildingId: document?.buildingId,
                                    folder: backend?.documents?.buildingDocuments,
                                    fileName: fileId,
                                    method: backend?.methods?.fileDelete,
                                    languageId: languageObj?.id,
                                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlFiles}/`,
                                };

                                result = await axios?.post(
                                    dataObj?.url,
                                    dataObj,
                                    headerObj,
                                );

                                response = result?.data;

                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: processValues?.auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return;
                                }
                                //#endregion delete file (physical)

                                //#region delete file (logical)
                                response = deleteFile({
                                    fileId: fileId,
                                    subMethod: currentMethod,
                                });

                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: processValues?.auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return;
                                }
                                //#endregion delete file (logical)

                                //#region update document (delete file)
                                document.files = buildingDocumentFilesLocal;

                                headerObj = {
                                    headers: {
                                        authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                                    },
                                };

                                dataObj = {
                                    document: document,
                                    languageId: languageObj?.id,
                                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${document?.id}`,
                                };

                                result = await axios?.post(
                                    dataObj?.url,
                                    dataObj,
                                    headerObj,
                                );

                                response = result?.data;

                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: processValues?.auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return;
                                }
                                //#endregion update document (delete file)

                                //#region building document files (datatable)
                                $(`#${dtFilesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                                //#endregion building document files (datatable)

                                //#region building documents (datatable)
                                filesDtRow = [];
                                filesDtRow.push([
                                    document?.title,
                                    document?.description,
                                    document?.files?.length || 0,
                                    buttonProcessGet({
                                        id: document?.id,
                                        description: document?.title,
                                        showDetails: true,
                                        labelDetails: labels?.detail?.[languageObj?.id],
                                        enabledDetails: true,
                                        showEdit: true,
                                        labelEdit: labels?.edit?.[languageObj?.id],
                                        enabledEdit: true,
                                        showDelete: true,
                                        labelDelete: labels?.delete?.[languageObj?.id],
                                        enabledDelete: true,
                                        processButtons: [],
                                        subMethod: currentMethod,
                                    })?.result,
                                ]);

                                $(`#${processValues?.dtId}`)?.DataTable()?.row(processValues?.dtRowIndex).data(filesDtRow[0])?.draw(true);
                                //#endregion building documents (datatable)

                                isDeleted = true;
                            } catch (ex) {
                                //#region Error
                                response.isSuccess = false;
                                response.msgType = -1;
                                response.msgText = `Method: ${currentMethod}<br/>`;
                                response.msgText += `Error: ${ex?.message}`;
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: processValues?.auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                //#endregion Error
                            }
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                    };

                    await Swal.fire(swalProperties);
                    //Swal.fire(swalProperties);
                    //#endregion show message
                }
            } else if (processValues?.type === 0) {
                //#region delete file (logical)
                response = deleteFile({
                    fileId: fileId,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: processValues?.auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion delete file (logical)

                //#region building document files (datatable)
                $(`#${dtFilesId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                //#endregion building document files (datatable)
                //isDeleted = true;
            }
            //#region finalMsg
            if (isDeleted) {
                response.msgType = 0;
                response.msgText = `${messages?.fileDeletedSuccessFully?.[languageObj?.id]}<br/>`;
                response.msgText += `${labels?.file?.[languageObj?.id]}: <b>${description}</b>`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
            //#endregion finalMsg
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return;
    }
    //#endregion methods (documents)

    //#region Methos (other)
    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod });
                controlsStatusSet({ processType: 2, subMethod: currentMethod });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }
            setProcessValues({ ...processValues, documentShowModal: !isModalClose, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const deleteFile = ({ fileId = '', subMethod = '', }) => {
        const currentMethod = 'deleteFile';
        let response = responseGet();
        try {
            let filesLocal = [];
            filesLocal = files?.filter(({ id }) => id !== fileId);
            setFiles(filesLocal);

            filesLocal = filesTwo?.filter(({ id }) => id !== fileId);
            setFilesTwo(filesLocal);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region dataTable set
            response = dataTablesSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region queryCode set
            response = queryCodeSet({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion queryCode set

            //#region load data (files)
            filesDtRow = [];
            if (!isUndNullEmp({ data: document, subMethod: currentMethod, })?.result && document?.files?.length > 0) {
                document?.files?.forEach((detail) => {
                    //#region data set
                    const customNameLocal = customFileNameGet({
                        fileName: detail?.name,
                        lengthStart: 0,
                        lengthReturn: 15,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    const customSizeLocal = formatBytes({
                        bytes: detail?.size,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    //#endregion data set
                    filesDtRow?.push([
                        customNameLocal,
                        customSizeLocal,
                        buttonProcessGet({
                            id: detail?.id,
                            description: customFileNameGet({
                                fileName: detail?.name,
                                lengthStart: 0,
                                lengthReturn: 15,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            showDetails: false,
                            labelDetails: '',
                            enabledDetails: false,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [
                                { isVisible: true, showDivider: false, isEnabled: true, methodName: processDocuments?.fileOpen, icon: icons?.folderOpen, label: labels?.open?.[languageObj?.id] },
                                { isVisible: true, showDivider: false, isEnabled: (processValues?.type !== 2), methodName: processDocuments?.fileDelete, icon: icons?.trash, label: labels?.delete?.[languageObj?.id] },
                            ],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });

                $(`#${dtFilesId}`)?.DataTable()?.rows?.add(filesDtRow)?.draw(true);

                setFiles(document?.files);
            }
            //#endregion load data (files)

            //#region filesAccept set
            let filesAcceptLocal = '';

            fileTypes?.forEach((detail, index) => {
                if ((index + 1) < fileTypes?.length) {
                    filesAcceptLocal += `${detail}, `;
                } else {
                    filesAcceptLocal += `${detail}`;
                }
            });

            setFilesAccept(filesAcceptLocal);
            //#endregion filesAccept set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const documentSaveAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'documentSaveAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region initialize
            filesDtRow = [];
            let fileUploads = [];
            let documentLocal = buildingDocumentModelGet({});
            //#endregion initialize

            //#region validate form
            response = await validateFormDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion validate form

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region Document create / edit / delete
            switch (processValues?.type) {
                case 0:
                    //#region add document
                    document.files = files;

                    headerObj = {
                        headers: {
                            authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        document: document,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: processValues?.auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    documentLocal = response?.result;
                    //#endregion add documents

                    //#region add files
                    if (!isUndNullEmp({ data: filesTwo, subMethod: currentMethod, })?.result && filesTwo?.length > 0) {
                        //#region file upload
                        for (let file of filesTwo) {
                            response = await fileUploadAsync({
                                folder: backend?.documents?.buildingDocuments,
                                file: file?.file,
                                fileName: file?.id,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: processValues?.auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }

                            fileUploads?.push({
                                id: file?.id,
                                name: file?.file?.name,
                                url: response?.result,
                                //url: response?.result?.url,
                            });
                        }
                        //#endregion file upload

                        //#region update files
                        fileUploads?.forEach((detail) => {
                            const fileLocal = files?.find(({ id }) => id === detail?.id);
                            if (!isUndNullEmp({ data: fileLocal, subMethod: currentMethod, })?.result) {
                                fileLocal.url = detail?.url;
                            }
                        });
                        //#endregion update files

                        //#region update document
                        documentLocal.files = files;

                        headerObj = {
                            headers: {
                                authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };

                        dataObj = {
                            document: documentLocal,
                            languageId: languageObj?.id,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${documentLocal?.id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: processValues?.auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion update document
                    }
                    //#endregion add files
                    break;
                case 1:
                    //#region Edit document
                    headerObj = {
                        headers: {
                            authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        document: document,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${document?.id}`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj
                    );

                    response = result.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: processValues?.auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    documentLocal = response.result;
                    //#endregion Edit document
                    break;
                default:
                    break;
            }
            //#endregion Document create / edit / delete

            //#region Close modal
            if (processValues?.type === 0) {
                filesDtRow.push([
                    documentLocal?.title,
                    documentLocal?.description,
                    documentLocal?.files?.length || 0,
                    buttonProcessGet({
                        id: documentLocal?.id,
                        description: documentLocal?.title,
                        showDetails: true,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: true,
                        processButtons: [],
                        subMethod: currentMethod,
                    })?.result,
                ]);

                $(`#${processValues?.dtId}`)?.DataTable()?.rows?.add(filesDtRow)?.draw(true);

                //await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            } else if (processValues?.type === 1) {
                filesDtRow = [];
                filesDtRow.push([
                    documentLocal?.title,
                    documentLocal?.description,
                    documentLocal?.files?.length || 0,
                    buttonProcessGet({
                        id: documentLocal?.id,
                        description: documentLocal?.title,
                        showDetails: true,
                        labelDetails: labels?.detail?.[languageObj?.id],
                        enabledDetails: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        showDelete: true,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: true,
                        processButtons: [],
                        subMethod: currentMethod,
                    })?.result,
                ]);

                $(`#${processValues?.dtId}`)?.DataTable()?.row(processValues?.dtRowIndex).data(filesDtRow[0])?.draw(true);
            }
            //#endregion Close modal

            //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const addFileAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'addFileAsync';
        let response = responseGet();
        try {

            e?.preventDefault();
            setAttachmentError('');
            //#region initialize
            let fileUrlLocal = '';
            let fileFindLocal = [];
            const valueLocal = e?.target?.value;
            const fileLocal = e?.target?.files[0];
            //#endregion initialize

            if (!isUndNullEmp({ data: valueLocal, subMethod: currentMethod, })?.result) {
                //#region check file
                response = checkFile({
                    fileType: fileLocal?.type,
                    fileSize: fileLocal?.size,
                    fileAllowedTypes: fileTypes,
                    fileMaxSize: globalSettings?.app?.fileSize?.max,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    $(`#${inputFileId}`).val('');
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: processValues?.auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion check file

                const idLocal = uuidv4();
                const customNameLocal = customFileNameGet({
                    fileName: fileLocal?.name,
                    lengthStart: 0,
                    lengthReturn: 15,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const customSizeLocal = formatBytes({
                    bytes: fileLocal?.size,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;

                //const fileFindLocal = files?.filter(
                fileFindLocal = files?.filter(
                    ({ name, size, type, path, }) => name === fileLocal?.name && size === fileLocal?.size && type === fileLocal?.type && path === valueLocal)[0];

                if (isUndNullEmp({ data: fileFindLocal, subMethod: currentMethod, })?.result) {
                    //#region check files maximum
                    if ((processValues?.type === 1 &&
                        !isUndNullEmp({ data: document?.files, subMethod: currentMethod, })?.result &&
                        document?.files?.length >= globalSettings?.app?.files?.buildingDocumentMaxFiles) ||
                        (processValues?.type === 0 && !isUndNullEmp({ data: files, subMethod: currentMethod, })?.result &&
                            files?.length >= globalSettings?.app?.files?.buildingDocumentMaxFiles)) {
                        response = documentMaxFilesMessageGet({
                            maxFiles: globalSettings?.app?.files?.buildingDocumentMaxFiles,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            $(`#${inputFileId}`).val('');
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: processValues?.auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                    }
                    //#endregion check files maximum

                    //#region upload file (new)
                    if (processValues?.type === 1) {
                        //#region upload file
                        controlsStatusSet({ processType: 3, subMethod: currentMethod, });

                        response = await fileUploadAsync({
                            folder: backend?.documents?.buildingDocuments,
                            file: fileLocal,
                            fileName: idLocal,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: processValues?.auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        fileUrlLocal = response?.result;
                        //#endregion upload file
                    } else if (processValues?.type === 0) {
                        fileUrlLocal = valueLocal;
                    }
                    //#endregion upload file (new)

                    const fileObjLocal = fileModelGet({
                        id: idLocal,
                        name: fileLocal?.name,
                        nameCustom: customNameLocal,
                        path: valueLocal,
                        size: fileLocal?.size,
                        sizeCustom: customSizeLocal,
                        type: fileLocal?.type,
                        url: fileUrlLocal,
                    });

                    setFiles([...files, fileObjLocal]);

                    setFilesTwo([...filesTwo, {
                        id: idLocal,
                        file: fileLocal,
                    }]);

                    //#region update document
                    // if (processValues?.type === 1 &&
                    //     isUndNullEmp({ data: fileFindLocal, subMethod: currentMethod, })?.result &&
                    //     !isUndNullEmp({ data: document?.files, subMethod: currentMethod, })?.result) {
                    if (processValues?.type === 1 &&
                        isUndNullEmp({ data: fileFindLocal, subMethod: currentMethod, })?.result) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        controlsStatusSet({ processType: 1, subMethod: currentMethod, });
                        document?.files.push(fileObjLocal);

                        //#region update document
                        headerObj = {
                            headers: {
                                authorization: `bearer ${processValues?.auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };

                        dataObj = {
                            document: document,
                            languageId: languageObj?.id,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBuildingDocuments}/${document?.id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: processValues?.auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion update document

                        //#region update datatable (Building documents)
                        filesDtRow = [];
                        filesDtRow.push([
                            document?.title,
                            document?.description,
                            document?.files.length || 0,
                            buttonProcessGet({
                                id: document?.id,
                                description: document?.title,
                                showDetails: true,
                                labelDetails: labels?.detail?.[languageObj?.id],
                                enabledDetails: true,
                                showEdit: true,
                                labelEdit: labels?.edit?.[languageObj?.id],
                                enabledEdit: true,
                                showDelete: true,
                                labelDelete: labels?.delete?.[languageObj?.id],
                                enabledDelete: true,
                                processButtons: [],
                                subMethod: currentMethod,
                            })?.result,
                        ]);

                        $(`#${processValues?.dtId}`)?.DataTable()?.row(processValues?.dtRowIndex).data(filesDtRow[0])?.draw(true);
                        //#endregion update datatable (Building documents)
                    }
                    //#endregion update document

                    //#region add dataTable row (Building documents)
                    filesDtRow = [];
                    filesDtRow.push(
                        customNameLocal,
                        customSizeLocal,
                        buttonProcessGet({
                            id: idLocal,
                            description: customFileNameGet({
                                fileName: fileLocal?.name,
                                lengthStart: 0,
                                lengthReturn: 15,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            showDetails: false,
                            labelDetails: '',
                            enabledDetails: false,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [
                                { isVisible: (processValues?.type === 1), showDivider: false, isEnabled: (processValues?.type === 1), methodName: processDocuments?.fileOpen, icon: icons?.folderOpen, label: labels?.open?.[languageObj?.id] },
                                { isVisible: true, showDivider: false, isEnabled: true, methodName: processDocuments?.fileDelete, icon: icons?.trash, label: labels?.delete?.[languageObj?.id] },
                            ],
                            subMethod: currentMethod,
                        })?.result,
                    );

                    $(`#${dtFilesId}`)?.DataTable()?.row?.add(filesDtRow)?.draw(true);
                    //#endregion add dataTable row (Building documents)
                }
            }

            $(`#${inputFileId}`).val('');

            if (processValues?.type === 1 && isUndNullEmp({ data: fileFindLocal, subMethod: currentMethod, })?.result) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 0,
                    msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: processValues?.auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }

    const dataTablesSet = ({ subMethod = '' }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            $(`#${dtFilesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: labels?.file?.[languageObj?.id], width: '70%', },
                    { title: labels?.size?.[languageObj?.id], className: 'text-right', width: '25%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id }),
                paging: false,
                searching: false,
                responsive: true,
                lengthChange: false,
                info: false,
                //}).buttons().container().appendTo(`#${dtBuildingsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const validateFormDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'validateFormDataSetAsync';
        let response = responseGet();
        try {
            if (isUndNullEmp({ data: document?.title, subMethod: currentMethod, })?.result) {
                setTitleError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: document?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (files?.length <= 0) {
                //#region old code
                // await sendMessageCloseCurrentWindowAsync({
                //     msgType: 1,
                //     msgText: messages?.youMustAddAtLeastOneFile?.[languageObj?.id],
                //     closeWindow: false,
                //     urlGoTo: response?.urlGoTo,
                //     auth: processValues?.auth,
                //     isLogout: false,
                //     languageId: languageObj?.id,
                //     subMethod: currentMethod,
                // });
                //#endregion old code
                setAttachmentError(messages?.youMustAddAtLeastOneFile?.[languageObj?.id]);
                response.isWarning = true;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: processValues?.auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let rowIndex = 0;
            let dtRowIndex = 0;
            //#endregion variables

            //#region methods
            $(`#${dtFilesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtFilesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    const id = e?.target?.attributes?.id?.value || '';
                    const method = e?.target?.attributes?.method?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case processDocuments?.fileOpen:
                            buildingDocumentFileOpen({ e: e, id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case processDocuments?.fileDelete:
                            buildingDocumentFileDeleteGetAsync({ e: e, fileId: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    //#region old code
                    // $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    // $(`#${controls?.buttons?.save?.id}`)?.removeClass();
                    // $(`#${controls?.spinners?.save?.id}`)?.removeClass();

                    // $(`#${controls?.icons?.save?.id}`)?.addClass(controls?.icons?.create.className);
                    // $(`#${controls?.buttons?.save?.id}`)?.addClass(controls?.buttons?.save?.className);
                    // $(`#${controls?.spinners?.save?.id}`)?.addClass(controls?.spinners?.create.className);
                    //#endregion old code

                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.attachment?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.attachment?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region inputs
            $(`#${controls?.inputs?.title?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.description?.id}`).attr('readOnly', (processType !== 0));
            //#endregion inpust

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : reactSett?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.attachment?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.delete?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(reactSett?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion Methos (other)

    return (
        <Modal backdrop='static' onHide={(e) => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - onHide', })} show={processValues?.documentShowModal}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.document?.[languageObj?.id]}
                        src={images?.documentLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.document?.[languageObj?.id]} ({processValues?.type === 0 ?
                            labels?.add?.[languageObj?.id]?.toLowerCase() :
                            processValues?.type === 1 ?
                                labels?.edit?.[languageObj?.id]?.toLowerCase() :
                                labels?.detail?.[languageObj?.id]?.toLowerCase()})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => (processValues?.type !== 2 ? documentSaveAsync({ e: e, subMethod: 'form - bntSave', }) : e?.preventDefault())}>
                <Modal.Body>
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <form onSubmit={(e) => (processValues?.type !== 2 ? documentSaveAsync(e) : e?.preventDefault())}> */}

                    {/* Header */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={labels?.document?.[languageObj?.id]} src={images?.documentLogo} style={styles?.cardHeaderLogo}></img> - {labels?.document?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* Body */}
                    {/* <div className='card-body'> */}
                    {/*create / edit*/}
                    {processValues?.type !== 2 ?
                        <div>
                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <input id={controls?.inputs?.title?.id}
                                        className={controls?.inputs?.title?.className}
                                        //autoFocus
                                        placeholder={labels?.title?.[languageObj?.id]}
                                        onChange={(e) => setDocument({ ...document, title: e?.target?.value, })}
                                        onFocus={() => setTitleError('')}
                                        value={document?.title || ''}
                                        tooltip='tooltip'
                                        title={labels?.title?.[languageObj?.id]} />
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.spellCheck} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(titleError)}</div>
                            </div>

                            <div className='form-group'>
                                <div className='input-group mb-3'>
                                    <textarea id={controls?.inputs?.description?.id}
                                        className={controls?.inputs?.description?.className}
                                        placeholder={labels?.description?.[languageObj?.id]}
                                        onChange={(e) => setDocument({ ...document, description: e?.target?.value, })}
                                        onFocus={() => setDescriptionError('')}
                                        value={document?.description || ''}
                                        tooltip='tooltip'
                                        title={labels?.description?.[languageObj?.id]}>
                                    </textarea>
                                    <div className='input-group-append'>
                                        <div className='input-group-text'>
                                            <span className={icons?.edit} />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                            </div>
                        </div>
                        :
                        <div>
                            {/*detail*/}
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.title?.[languageObj?.id]}</b>
                                </div>
                                <div className='col-md-8'>
                                    {document?.title || ''}
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.description?.[languageObj?.id]}</b>
                                </div>
                                <div className='col-md-8'>
                                    {!isUndNullEmp({ data: document?.description, subMethod: 'label - description', })?.result ?
                                        HtmlParser(document?.description?.replaceAll('\n', '<br/>'))
                                        : ''
                                    }
                                </div>
                            </div>
                        </div>
                    }

                    <div className='row'>
                        <div className='col-md-12'>
                            <LoadingSection alt='loadingSection'
                                className={reactSett?.html?.overlay?.darkTextWhite}
                                showText={true}
                                text={messages?.processing?.[languageObj?.id]}
                                height={25}
                                hidden={!showLoading?.files}
                                width={25}
                                languageId={languageObj?.id}
                                subMethod={currentMethod} />

                            <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                <table id={dtFilesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                            </div>
                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(attachmentError)}</div>
                        </div>
                    </div>

                    {/* </div> */}

                    {/* Footer */}
                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-primary mx-1'
                                    hidden={!isUndefined(processValues) && !isUndefined(processValues?.type) && !isNull(processValues?.type) && processValues?.type === 2}
                                    tooltip='tooltip'
                                    title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <div className='btn btn-outline-info btn-file'
                                    hidden={!isUndefined(processValues) && !isUndefined(processValues?.type) && !isNull(processValues?.type) && processValues?.type === 2}>
                                    <i className={icons?.paperClip}></i>
                                    <input id={inputFileId}
                                        accept={filesAccept}
                                        tooltip='tooltip'
                                        title={labels?.toAttach?.[languageObj?.id]}
                                        type='file'
                                        name='attachment'
                                        onChange={(e) => addFileAsync(e)} />
                                </div>
                                <button id={controls?.buttons?.delete?.id}
                                    hidden
                                    className='btn btn-outline-danger'
                                    onClick={(e) => buildingDocumentFileDeletePostAsync(e)}
                                    type='button'>
                                </button>
                                <button className='btn btn-outline-success mx-1'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='button'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}

                    {/* </form> */}
                    {/* </div> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processValues?.type === 2}
                            tooltip='tooltip'
                            title={processValues?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <div id={controls?.buttons?.attachment?.id}
                            className={controls?.buttons?.attachment?.className}
                            //className='btn btn-outline-info btn-file'
                            hidden={processValues?.type === 2}>
                            {/* <i className={icons?.paperClip}></i> */}
                            <i id={controls?.icons?.attachment?.id} className={controls?.icons?.attachment?.className} /> <span id={controls?.spinners?.attachment?.id} className='' aria-hidden='true'></span>
                            <input id={inputFileId}
                                accept={filesAccept}
                                tooltip='tooltip'
                                title={labels?.toAttach?.[languageObj?.id]}
                                type='file'
                                name='attachment'
                                onChange={(e) => addFileAsync({ e: e, subMethod: 'btn - fileAdd', })}
                                onClick={() => setAttachmentError('')} />
                        </div>
                        <button id={controls?.buttons?.delete?.id}
                            className={controls?.buttons?.delete?.className}
                            hidden
                            onClick={(e) => buildingDocumentFileDeletePostAsync({ e: e, subMethod: 'modal - btnBuildingDocumentDelete', })}
                            type='button'>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='button'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'modal - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}